<template>
  <section :id="$style.central_movie_visual">
    <div :class="$style.overview">
      <p>
        <br />
        『松井秀喜と野球』をテーマとした4本の映像を<br :class="$style.sp_indention" />
        日本語字幕、英語字幕で繰り返し上映しています。<br :class="$style.sp_indention" />
        <br />合計上映時間 : 65分
      </p>
    </div>
    <div :class="$style.article">
      <div :class="$style.studiam"></div>
      <div :class="$style.studiam2"></div>
      <div :class="$style.boy"></div>
      <div :class="$style.sunset"></div>
      <div :class="$style.sunset2"></div>
      <div :class="$style.sunset3"></div>
      <div :class="$style.sunset4"></div>
      <div :class="$style.sunset5"></div>
      <div :class="$style.sunset6"></div>
      <div :class="$style.sunset7"></div>
      <div :class="$style.sunset8"></div>
      <div :class="$style.sunset9"></div>
      <div :class="$style.sunset10"></div>
      <div :class="$style.sunset11"></div>
      <div :class="$style.sunset12"></div>
      <div :class="$style.sunset13"></div>
      <div :class="$style.cheer"></div>
      <div :class="$style.globe"></div>
      <div :class="$style.sunset_a"></div>
      <div :class="$style.sunset_b"></div>
      <div :class="$style.sunset_c"></div>
      <div :class="$style.sunset_d"></div>
      <div :class="$style.sunset_e"></div>
      <div :class="$style.sunset_f"></div>

      <my-dream-visual :class="$style.my_dream" id="my_dream"></my-dream-visual>
      <world-visual :class="$style.world" id="world"></world-visual>
      <matsui-homerun-visual
        :class="$style.matsui_homerun"
        id="matsui_homerun"
      ></matsui-homerun-visual>
      <jeter-visual :class="$style.jeter" id="jeter"></jeter-visual>
    </div>
    <!--<movie-image-visual></movie-image-visual>
    <movie-text-visual></movie-text-visual>-->
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import MyDreamVisual from "../../../components/organsms/movie/MyDreamVisual";
import WorldVisual from "../../../components/organsms/movie/WorldVisual";
import MatsuiHomerunVisual from "../../../components/organsms/movie/MatsuiHomerunVisual";
import JeterVisual from "../../../components/organsms/movie/JeterVisual";

export default Vue.extend({
  name: "CentralMovieView",

  components: {
    MyDreamVisual,
    WorldVisual,
    MatsuiHomerunVisual,
    JeterVisual,
  },
});
</script>

<style lang="scss" module>
@import "../../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #central_movie_visual {
    background-color: #000011;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;

    .main_title {
      margin-bottom: 10px;
      align-items: center;
    }
    .overview {
      margin: 2em 0;
      text-align: center;
      color: #fff;
    }

    #button_area {
      margin-top: 40px;
      .button {
        width: 130px;
        margin: 0px 10px;
      }
    }
    .article {
      display: grid;
      grid-template-columns: 1fr 70% 1fr;
      justify-items: center;
      align-items: center;

      .my_dream {
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 20px 20px;
        grid-column: 2;
        grid-row: 2;
      }
      .world {
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 20px 20px;
        grid-column: 2;
        grid-row: 4;
      }
      .matsui_homerun {
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 20px 20px;
        grid-column: 2;
        grid-row: 6;
      }
      .jeter {
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 20px 20px;
        grid-column: 2;
        grid-row: 8;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #central_movie_visual {
    background-color: #000011;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;

    .overview {
      margin: 2em 0;
      text-align: center;
      color: #fff;
    }

    .main_title {
      text-align: center;
    }

    #button_area {
      /*margin-right: 500px;*/
      margin-top: 40px;
      .button {
        width: 130px;
        margin: 0px 10px;
      }
    }

    .article {
      display: grid;
      grid-template-columns: 1fr 45% 1fr;
      justify-items: center;
      align-items: center;

      .my_dream {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: auto 0px;
        padding: 40px 40px;
        grid-column: 2;
        grid-row: 2;
      }
      .world {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: auto 0px;
        padding: 40px 40px;
        grid-column: 2;
        grid-row: 4;
      }
      .matsui_homerun {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: auto 0px;
        padding: 40px 40px;
        grid-column: 2;
        grid-row: 6;
      }
      .jeter {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: auto 0px;
        padding: 40px 40px;
        grid-column: 2;
        grid-row: 8;
      }

      .sunset {
        grid-column: 1;
        grid-row: 1;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;

        background-image: url("../../../assets/img/movie/ce1_movie1.jpg");
      }
      .sunset2 {
        grid-column: 3;
        grid-row: 1;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;

        background-image: url("../../../assets/img/movie/ce1_movie2.jpg");
      }
      .sunset9 {
        grid-column: 1;
        grid-row: 2;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce1_movie3.jpg");
      }
      /*
      .sunset3 {
        grid-column: 3;
        grid-row: 2;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 340px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce1_movie4.jpg");
      }*/
      .sunset10 {
        grid-column: 1;
        grid-row: 3;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce1_movie5.jpg");
      }
      .cheer {
        grid-column: 3;
        grid-row: 2;
        margin: 0px auto;
        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;

        background-image: url("../../../assets/img/movie/ce1_movie6.jpg");
      }
      .sunset11 {
        grid-column: 1;
        grid-row: 4;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce2_movie1.jpg");
      }
      /*
      .sunset4 {
        grid-column: 3;
        grid-row: 4;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 350px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce2_movie2.jpg");
      }
      */
      .globe {
        grid-column: 1;
        grid-row: 5;
        margin: auto 0px;
        padding: 70px 80px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;

        background-image: url("../../../assets/img/movie/ce2_movie3.jpg");
      }
      .sunset5 {
        grid-column: 3;
        grid-row: 3;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce2_movie4.jpg");
      }
      /*
      .sunset12 {
        grid-column: 1;
        grid-row: 6;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 340px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce2_movie5.jpg");
      }
      */
      .sunset6 {
        grid-column: 3;
        grid-row: 4;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce2_movie6.jpg");
      }
      .sunset13 {
        grid-column: 1;
        grid-row: 6;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 180px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce3_movie1.jpg");
      }

      .studiam {
        grid-column: 3;
        grid-row: 5;
        margin: auto 0px;
        padding: 70px 80px;
        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;

        background-image: url("../../../assets/img/movie/ce3_movie2.jpg");
      }
      /*
      .studiam2 {
        grid-column: 1;
        grid-row: 8;
        margin: auto 0px;
        padding: 70px 80px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 350px;
        height: 200px;

        background-image: url("../../../assets/img/movie/ce3_movie3.jpg");
      }
      */
      .sunset7 {
        grid-column: 3;
        grid-row: 6;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce3_movie4.jpg");
      }
      .boy {
        grid-column: 1;
        grid-row: 7;
        margin: auto 0px;
        padding: 70px 80px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;

        background-image: url("../../../assets/img/movie/ce3_movie5.jpg");
      }
      /*
      .sunset8 {
        grid-column: 3;
        grid-row: 9;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 340px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../../assets/img/movie/ce3_movie6.jpg");
      }
      */
      .sunset_a {
        grid-column: 3;
        grid-row: 7;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;

        background-image: url("../../../assets/img/movie/ce4_movie1.jpg");
      }
      .sunset_b {
        grid-column: 3;
        grid-row: 8;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;

        background-image: url("../../../assets/img/movie/ce4_movie2.jpg");
      }

      .sunset_c {
        grid-column: 1;
        grid-row: 8;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;

        background-image: url("../../../assets/img/movie/ce4_movie3.jpg");
      }
      /*
      .sunset_d {
        grid-column: 3;
        grid-row: 11;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 340px;
        height: 200px;
        align-items: center;
        align-content: center;

        background-image: url("../../../assets/img/movie/ce4_movie4.jpg");
      }
      */
      .sunset_e {
        grid-column: 1;
        grid-row: 9;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 170px;
        align-items: center;
        align-content: center;

        background-image: url("../../../assets/img/movie/ce4_movie5.jpg");
      }
      .sunset_f {
        grid-column: 3;
        grid-row: 9;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 280px;
        height: 160px;
        align-items: center;
        align-content: center;

        background-image: url("../../../assets/img/movie/ce4_movie6.jpg");
      }
    }
  }
}
</style>
